import React from "react";
import Axios from "axios";

// components
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PrivateRoute, AuthProvider } from "./auth";
import { View } from "components/lib";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

// 404
import { NotFound } from "views/error/404";

// tailwind css
import "../css/output.css";

// settings
const Settings = require("settings.json");
const StripePromise = loadStripe(
  Settings[process.env.NODE_ENV].stripe.publishableAPIKey
);

// Interceptor global: si el servidor responde 401 (sesión expirada o inválida)
// teniendo una sesión activa, cierra sesión y regresa al login. Se excluye
// /api/auth para no confundir con "credenciales incorrectas" en el login ni con
// la validación inicial de sesión (que ya cierra sesión por su cuenta).
// El aviso NO se muestra aquí (el redirect recargaría y lo mataría): se deja
// una marca en sessionStorage y el AuthProvider lo muestra al cargar el destino,
// así el mensaje persiste tras salir al login.
let sesionExpiradaAvisada = false;
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const cache = JSON.parse(localStorage.getItem("user") || "null");
    if (
      status === 401 &&
      cache?.token &&
      !url.includes("/api/auth") &&
      !sesionExpiradaAvisada
    ) {
      sesionExpiradaAvisada = true;
      sessionStorage.setItem("sesion_expirada", "1");
      localStorage.clear();
      window.location = "/";
    }
    return Promise.reject(error);
  }
);

const routes = [
  ...require("routes/setup").default,
  ...require("routes/account").default,
  ...require("routes/accounting").default,
  ...require("routes/app").default,
  ...require("routes/auth").default,
  ...require("routes/website").default,
];

export default function App(props) {
  const user = JSON.parse(localStorage.getItem("user"));
  Axios.defaults.baseURL = Settings[process.env.NODE_ENV].server_url;

  if (user?.token) {
    // add auth token to api header calls
    Axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
  }

  // render the routes
  return (
    <Elements stripe={StripePromise}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {routes.map((route) => {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    route.permission ? (
                      <PrivateRoute permission={route.permission}>
                        <View
                          display={route.view}
                          layout={route.layout}
                          title={route.title}
                        />
                      </PrivateRoute>
                    ) : (
                      <View
                        display={route.view}
                        layout={route.layout}
                        title={route.title}
                      />
                    )
                  }
                />
              );
            })}

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </Elements>
  );
}
